<template>
  <div class="canada_page">
    <div class="header">
      <div class="content">
        <a class="logo" href="https://www.kkpoker.net/" target="_blank">
          <img src="/static/img/desktop/header_kk_logo.png" alt="logo" />
        </a>
        <!-- <div class="menu">
          <a
            v-for="(menu, index) of menuList"
            :key="index"
            :href="menu.link"
            target="_blank"
            >{{ menu.label }}</a
          >
        </div>
        <div class="follow" v-if="$root.currentType !== 'curacao'">
          <a target="_blank" href="https://www.facebook.com/kkpokerglobal/">
            <img
              class="facebook-img"
              src="/static/img/desktop/header_FB_icon.png"
            />
          </a>
          <a target="_blank" href="https://www.instagram.com/kkpoker.canada/">
            <img
              class="ins-img"
              src="/static/img/desktop/header_Inst_icon.png"
            />
          </a>
        </div> -->
      </div>
    </div>

    <div class="container">
      <div class="main-block">
        <div class="left-section">
          <img src="/static/img/canada/eu/left_banner.png" />
        </div>
        <div class="right-section">
          <div class="register-block settingHeight">
            <registerForm :platform="platform"></registerForm>
          </div>
          <div class="download-block">
            <download-button @setPlatform="platform = $event" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="olakk-modal"
      :class="{ show: showTutorial }"
      ref="olakkModal"
      @click="openTutorial"
    >
      <img class="pc" src="/static/img/desktop/KK-download.jpg" />
      <img class="mb" src="/static/img/desktop/KK-download-mb.jpg" alt="" />
    </div>

    <div class="highlight_block">
      <div class="bg_top" >
      </div>
      <div class="bg_bottom"></div>
      <div class="contain">
        <div class="post">
          <div class="post_header">
            <div class="title">
              First Deposit Bonus!
            </div>
            $100 Reward!
          </div>
          <img src="/static/img/canada/post_bonus.jpg" alt="post_bonus">
        </div>
        <div class="post">
          <div class="post_header">
            <div class="title">
              FREEROLL
            </div>
            every 6 hours!
          </div>
          <img src="/static/img/canada/eu/post_freerolls.jpg" alt="post_freerolls">
        </div>
      </div>
    </div>

    <div class="step_block">
      <div class="step" v-for="(step, index) of stepList" :key="index">
        <img
          :src="`/static/img/canada/${step.image}`"
        />
        <div>
          <div>STEP {{ index + 1 }}</div>
          <div class="content">{{ step.label }}</div>
        </div>
      </div>
    </div>

    <div class="hand_block">
      <div class="kk_description">
        <div class="logo_title">
          <div class="main_content">KKPOKER</div>
          <div>Your Best Way to Play!</div>
        </div>
        <div>
          <div class="card">
            <img
              src="/static/img/canada/protection_icon.png"
              alt="protection_icon"
            />
            <div>
              <div class="card_title">
                FUNDS FULLY PROTECTED
              </div>
              Fully licensed by the Isle of Man Gambling Supervision Commission
            </div>
          </div>
          <div class="card">
            <img
              src="/static/img/canada/withdrawal_icon.png"
              alt="withdrawal_icon"
            />
            <div>
              <div class="card_title">
                EASY DEPOSITS & WITHDRAWALS
              </div>
              Debit/Credit Card, Crypto Currencies and More!
            </div>
          </div>

          <div class="card">
            <img
              src="/static/img/canada/mobile_icon.png"
              alt="withdrawal_icon"
            />
            <div>
              <div class="card_title">
                MTT & CASH GAME 7/24
              </div>
              90+ MTTs Daily! Plus Bonus Missions!
            </div>
          </div>
        </div>
      </div>

      <div class="kk_image"></div>
    </div>

    <div class="payment-block">
      <div class="content">
        <img
          :src="`/static/img/canada/payment_${isMobile ? 'mb' : 'pc'}.jpg`"
        />
      </div>
    </div>
    <div style="width: 100%; height: 1px; background-color: #4C4C4C;"></div>

    <div class="terms">
      <div class="content">
        <p>
          The products and services that KKPoker offers (via its websites,
          tablet and mobile applications) are together referred to as the
          "Services".
        </p>
        <p>
          Access to Services may not be legal for residents of, or persons
          located in,
          <a
            class="primary_color"
            :href="globalConfig.noticeCountries"
            target="_blank"
            >certain countries</a
          >. Services provided hereunder do not constitute an offer,
          solicitation or invitation by KKPoker for the use of, or subscription
          to, betting, gaming or other services in any jurisdiction in which
          such activities are prohibited by law. In particular, residents of or
          persons located in the United States shall not use any of the
          Services.
        </p>
        <p>
          KKPoker is a brand and registered business name, owned by Aceking IOM
          Limited (company number 017019V), 49 Victoria Street, Douglas, Isle of
          Man, IM1 2LD.
        </p>
        <p>
          Regulated & Licensed by Isle of Man Gambling Supervision Commission
          pursuant to the Online Gambling Regulation Act 2001 since 24th July,
          2019 (Last Renewal: 24th July, 2024). Persons under the age of 18 are
          not allowed to create accounts and/or participate in gambling. All
          online gambling debts are enforceable in law in the Isle of Man.
        </p>
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <strong class="copyright">
          Copyright © {{ currentYear }} KKPoker. All Rights Reserved.
        </strong>
        <div class="jump_btn">
          <a
            v-if="globalConfig.iconHref"
            target="_blank"
            :href="globalConfig.iconHref"
            ><img class="icon_06" :src="globalConfig.icon"
          /></a>
          <a
            target="_blank"
            href="https://access.gaminglabs.com/Certificate/Index?i=429"
            ><img class="icon_07" src="/static/img/home/gli.jpeg"
          /></a>
          <a target="_blank" href="https://www.gamcare.org.uk/"
            ><img class="icon_08" src="/static/img/home/icon_08.png"
          /></a>
          <a target="_blank" href="https://www.begambleaware.org/"
            ><img class="icon_09" src="/static/img/home/GambleAware.png"
          /></a>
          <a><img class="icon_10" src="/static/img/home/icon_10.png"/></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadButton from "../components/downloadButton.vue";
import registerForm from "@/components/registerForm.vue";
import { setClubBannerImage } from "../configs/clubs";
import { uploadTrack } from "../configs/userStatsTrack";

/**
 * only show on olakk desktop with lang pt
 */
export default {
  name: "olakk-desktop",
  components: { DownloadButton, registerForm },
  data() {
    const isMobile = window.innerWidth <= 767;
    return {
      platform: "", // temporarily abandoned
      isMobile,
      currentYear: new Date().getFullYear(),
      showTutorial: false,
      stepList: [
        { label: "REGISTER", image: "step3=step1.png" },
        { label: "DOWNLOAD KKPOKER APP", image: "step3=step2.png" },
        { label: "DEPOSIT & GET BONUS", image: "step3=step3.png" }
      ],
      menuList: [
        { link: "https://www.kkpoker.net/tournaments", label: "TOURNAMENT" },
        { link: "https://www.kkpoker.net/promotions", label: "PROMOTIONS" },
        { link: "https://www.kkpoker.net/blog", label: "BLOG" }
      ]
    };
  },
  methods: {
    openTutorial() {
      this.$refs.olakkModal.scrollTop = 0;
      this.showTutorial = !this.showTutorial;
    },
    track(deviceType) {
      const category = "SignUp Special PC";
      this.$gtag.event("Click", {
        event_category: category,
        event_label: `Download ${deviceType}`
      });
      // upload track data to aliyun
      uploadTrack(this);
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
@import url('https://fonts.googleapis.com/css?family=Oswald');

.canada_page {
  * {
    font-family: Oswald;
  }
}
.container {
  display: block;
  position: relative;
  width: 100%;
  height: 87vh;
  background-image: url("  /static/img/canada/eu/headerback.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media only screen and (max-width: 970px) {
    height: 215vw;
    padding-top: 100px;
  }
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  padding: 10px 20px;
  background: rgba(0, 0, 0, 0.8);

  .content {
    margin: 0 auto;
    max-width: 1600px;
    height: 60px;
    display: flex;
    flex-direction: row;
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    img {
      height: 100%;
    }
  }

  .menu {
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      display: block;
      color: #f2f2f2;
      text-align: center;
      padding: 10px 20px;
      text-decoration: none;
      font-size: 25px;
      font-weight: bold;
      text-transform: uppercase;

      &:hover {
        border-bottom: 3px solid #219655;
      }
    }
  }

  .follow {
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
      margin-bottom: 20px;
      color: #8a8a8a;
      font-size: 18px;
    }

    img {
      display: inline-block;
    }

    a {
      display: inline-block;
      margin-right: 48px;
      vertical-align: middle;
    }

    .facebook-img {
      width: 24px;
    }

    .ins-img {
      width: 38px;
    }

    .twitter-img {
      width: 47px;
    }
  }
}

.main-block {
  margin: 0 auto;
  max-width: 1600px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;

  @media only screen and (max-width: 970px) {
    flex-direction: column;
    justify-content: flex-start;
  }

  .left-section {
    margin-top: 10%;

    @media only screen and (max-width: 970px) {
      margin-top: 0;
      max-width: 70%;
    }
    img {
      width: 900px;

      @media only screen and (max-width: 970px) {
        width: 100%;
      }
    }
  }
}

.payment-block {
  background-color: black;

  .content {
    margin: 0 auto;
    max-width: 1600px;

    img {
      display: block;
      width: 100%;
    }
  }
}

.right-section {
  display: flex;
  width: fit-content;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9;
  // margin-top: 100px;

  @media screen and (max-width: 1000px) {
    // margin: 0 auto;
    margin-top: -150px;
  }

  * {
    box-sizing: border-box;
  }

  .register-block {
    // margin: -10% 0;
    transform: scale(0.8);
    width: 850px;
    height: 950px;
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #151515;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  }
}

.terms {
  padding: 100px 20px;
  background-color: black;

  .content {
    margin: 0 auto;
    max-width: 1600px;
  }

  p {
    color: #fff;
    font-size: 20px;
    line-height: 1.5;
    margin-bottom: 32px;
  }

  a {
    color: #219655;
    box-shadow: 0 1px;
    font-size: 20px;
    text-decoration: none;
  }
}

.footer {
  width: 100%;
  background: rgba(0, 0, 0, 1);

  .content {
    padding: 10px 0;
    margin: 0 auto;
    max-width: 1600px;
    height: 70px;
    display: flex;
    align-items: center;
    flex-direction: row;

    @media only screen and (max-width: 767px) {
      height: 100%;
      flex-direction: column;
    }
  }

  .copyright {
    color: rgb(140, 140, 140);
    font-size: 25px;
    font-weight: bold;
  }

  .jump_btn {
    margin-left: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;

    @media only screen and (max-width: 767px) {
      margin-left: unset;
      padding: 30px 0;
    }

    a {
      display: inline-block;
      margin: 0 10px;
      // cursor: pointer;
    }

    img {
      display: inline-block;
      vertical-align: middle;
      // margin: 0px 16px;
    }

    .icon_06 {
      width: 76px;
    }

    .icon_07 {
      width: 97px;
    }

    .icon_08 {
      width: 89px;
    }

    .icon_09 {
      width: 165px;
    }

    .icon_10 {
      width: 48px;
    }
  }
}

.olakk-modal {
  display: none;
  position: fixed;
  text-align: center;
  z-index: 11;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);

  .mb {
    display: none;
  }

  img {
    width: 90%;
    margin: 5% 0;
  }

  @media only screen and (max-width: 767px) {
    .pc {
      display: none;
    }

    .mb {
      display: inline-block;
    }
  }

  &.show {
    display: block;
  }
}

.highlight_block {
  position: relative;
  margin-top: -1px;

  .contain {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 1600px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    @media only screen and (max-width: 767px) {
      flex-direction: column;
    }
  }

  .bg_top {
    height: 200px;
    width: 100%;
    background-image: url(/static/img/canada/post_bg_top.jpg);
    background-size: cover;

    @media only screen and (max-width: 767px) {
      height: 400px;
    }
  }

  .bg_bottom{
    height: 500px;
    width: 100%;
    background-image: url(/static/img/canada/post_bg.jpg);
    background-size: cover;

    @media only screen and (max-width: 767px) {
      height: 1000px;
    }
  }

  .post_header {
    padding: 20px 0;
  }

  .post {
    position: relative;
    margin: 20px 30px;
    width: 500px;
    height: 600px;
    border-radius: 0px 30px 0px 0px;
    background: rgba(255, 255, 255, 1);
    font-size: 40px;
    line-height: 1.2;
    font-weight: 700;
    text-align: center;
    color: black;

    @media only screen and (max-width: 767px) {
      border: 1px solid #dcdcdc;
    }

    img {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;

    }
  }

  .title {
    color: #219655;
  }
}

.step_block {
  margin: 20px auto;
  max-width: 1600px;
  display: flex;
  flex-direction: row;
  font-size: 50px;

  @media (max-width: 767px) {
    flex-direction: column;
  }

  .step {
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: white;
    width: 33%;
    font-size: 70px;

    @media (max-width: 600px) {
      justify-content: start;
      width: 100%;
    }

    .content {
      font-size: 30px;
    }
  }

  img {
    width: 100%;
    max-width: 160px;
    height: auto;
    margin-right: 30px;
  }
}

.hand_block {
  position: relative;
  color: black;
  font-size: 50px;
  background-color: white;

  @media screen and (max-width: 969px) {
    font-size: unset;
  }

  .kk_image {
    width: 100%;
    height: 60vw;
    background-image: url(/static/img/canada/KK_HandBanner.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: left bottom;

    @media screen and (max-width: 969px) {
      height: 90vw;
    }
  }

  .kk_description {
    position: absolute;
    z-index: 1;
    top: 5%;
    right: 5%;
    width: 40%;

    @media screen and (max-width: 969px) {
      position: relative;
      top: 0;
      right: 0;
      width: 100%;
    }
  }

  .logo_title {
    margin: 60px 0;
    padding: 40px 0;
    position: relative;
    font-size: 3vw;

    @media screen and (max-width: 969px) {
      font-size: unset;
      text-align: center;
    }

    .main_content {
      // color: #219655;
      font-weight: 700;
    }

    &::after {
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 200px;
      height: 8px;
      background: #219655;

      @media screen and (max-width: 969px) {
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .card {
    margin: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 2vw;

    @media screen and (max-width: 969px) {
      font-size: 40px;
    }

    .card_title {
      color: #219655;
      font-weight: 700;
    }
  }

  img {
    width: 120px;
    margin-right: 20px;
  }
}

.primary_color {
  color: #289753;
}
</style>
<style lang="less">
// overwrite register component
.register-block {
  .top,
  .my-swipe,
  .float_bottom {
    display: none;
  }

  .register-form .content {
    background-image: unset;
  }
}

.download-block {
  // padding-top: 50px;
  margin-top: -80px;
  width: 680px;

  .download {
    justify-content: space-between;
    flex-wrap: wrap;

    div {
      width: 48%;
    }

    a img.download_box {
      margin: 0;
      width: 100% !important;
    }
  }
}
</style>
